import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDetalleMercaderiaFumigada } from '../../actions/listados'
import TablaDetalleMercaderiaFumigadaView from '../../components/listados/TablaDetalleMercaderiaFumigadaView'

function DetalleMercaderiaFumigada (props) {
  const { detalle, fechaDesde, fechaHasta, actualizarDetalleMercaderiaFumigada } = props

  useEffect(() => {
    actualizarDetalleMercaderiaFumigada(fechaDesde, fechaHasta, detalle.exportador, detalle.cereal)
  }, [actualizarDetalleMercaderiaFumigada, fechaDesde, fechaHasta, detalle])

  return (
    <TablaDetalleMercaderiaFumigadaView />
  )
}

const mapActionsToProps = {
  actualizarDetalleMercaderiaFumigada
}

const mapStateToProps = state => {
  return {
    fechaDesde: state.stock.fechaDesde,
    fechaHasta: state.stock.fechaHasta
  }
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleMercaderiaFumigada)
